import { TaasStatus } from '@ps20/bff-models';
import {
  GlobalAction,
  GlobalActions,
  GlobalPut,
  ModalCloseReason,
  ModalType,
} from '@ps20-frontend/shop-integration-redux';
import { call, take } from 'redux-saga/effects';
import { showTaasStatusModal, taasReturnStatus } from './errorHandlingTarifierung';

export function* handleTarifierungsReturnCodeInShop(
  taasStatus: TaasStatus,
  originEvent: GlobalAction<unknown>,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
): any {
  const globalPut = GlobalPut.getInstance();

  const modalTypeForTaasStatus = getModalTypeForTaasStatus(taasStatus);

  if (modalTypeForTaasStatus) {
    yield call(showTaasStatusModal, taasStatus);
    const closeModalAction = yield take(GlobalActions.CLOSE_MODAL);

    if (shouldTriggerRetryAction(taasStatus, closeModalAction)) {
      yield call(globalPut.put, originEvent);
    }
  } else {
    yield call(showDefaultErrorModalInShop, originEvent);
  }
}

export function* showDefaultErrorModalInShop(
  originalEvent: GlobalAction<unknown>,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
): any {
  const globalPut = GlobalPut.getInstance();
  switch (originalEvent.type) {
    case GlobalActions.VERSICHERUNGSBEGINN_CHANGED:
    case GlobalActions.VORVERSICHERUNG_VORHANDEN_CHANGED:
      return yield call(
        globalPut.put,
        new GlobalActions().requestModal(ModalType.PREISE_CHECKOUT_ERROR),
      );
    default:
      return yield call(
        globalPut.put,
        new GlobalActions().requestModal(ModalType.PREISE_SHOP_ERROR),
      );
  }
}

function getModalTypeForTaasStatus(taasStatus: TaasStatus): ModalType {
  return taasStatus && taasStatus.returnCodeTaas && taasReturnStatus(taasStatus.returnCodeTaas);
}

function shouldTriggerRetryAction(taasStatus: TaasStatus, closeModalAction: GlobalAction<ModalCloseReason>): boolean {
  return (
    taasReturnStatus(taasStatus.returnCodeTaas) === ModalType.TAAS_FEHLER_MIT_RETRY &&
    closeModalAction.payload === ModalCloseReason.PRIMARY
  );
}
